import {
  Typography, Link
} from "@mui/material";
import {
  Home as HomeIcon,
  Help as HelpIcon,
  Apps as AppsIcon,
  LockOpen as LockOpenIcon,
  Construction as ConstructionIcon,
  SportsEsports as SportsEsportsIcon,
  SmartToy as SmartToyIcon,
  Verified as VerifiedIcon,
  CatchingPokemon as CatchingPokemonIcon,
  ElectricBolt as ElectricBoltIcon,
  EmojiEmotions as EmojiEmotionsIcon,
  VideoCameraBack as VideoCameraBackIcon,
  Update as UpdateIcon,
  Filter as FilterIcon,
  DinnerDining as DinnerDiningIcon,
  Quiz as QuizIcon,
  PhotoFilter as PhotoFilterIcon,
  Balance as BalanceIcon,
  QuestionAnswer as QuestionAnswerIcon,
  RecordVoiceOver as RecordVoiceOverIcon,
  Lan as LanIcon,
  TrendingUp as TrendingUpIcon,
  PersonAdd as PersonAddIcon,
  AllInbox as AllInboxIcon,
  BugReport as BugReportIcon,
  Style as StyleIcon,
  Favorite as FavoriteIcon,
} from "@mui/icons-material";
import {
  red,
  pink,
  purple,
  deepPurple,
  indigo,
  blue,
  lightBlue,
  cyan,
  teal,
  green,
  lightGreen,
  lime,
  yellow,
  amber,
  orange,
  deepOrange,
  brown,

  blueGrey,
} from "@mui/material/colors";
import SignOut from "../components/SignOut";
import UpdateNickname from "../components/UpdateNickname";

// アプリのカテゴリタグ
export const tagList = [
  {
    label: "すべて",
    icon: <AppsIcon />
  },
  {
    label: "サインイン不要",
    icon: <LockOpenIcon />
  },
  {
    label: "ユーティリティ",
    icon: <ConstructionIcon />
  },
  {
    label: "ゲーム",
    icon: <SportsEsportsIcon />
  },
  {
    label: "AI",
    icon: <SmartToyIcon />
  },
  {
    label: "オリジナル",
    icon: <VerifiedIcon />
  },
  {
    label: "ポケモン",
    icon: <CatchingPokemonIcon />
  }
];
// アプリ一覧
export const appList = [
  {
    title: "電気椅子ゲーム",
    icon: <ElectricBoltIcon />,
    color: yellow,
    url: "https://electric-chair-game.pages.dev/",
    public: true,
    tags: [3]
  },
  {
    title: "タロット占い",
    icon: <StyleIcon />,
    color: deepPurple,
    url: "https://tarots-reading.pages.dev/",
    public: true,
    tags: [2, 4, 5]
  },
  {
    title: "タイプ推しメーカー",
    icon: <FavoriteIcon />,
    color: pink,
    url: "https://type-oshi-maker.pages.dev/",
    public: true,
    tags: [6]
  },
  {
    title: "ポジティブBluesky",
    icon: <EmojiEmotionsIcon />,
    color: lightBlue,
    url: "https://positive-bluesky.pages.dev/",
    public: true,
    tags: [2, 4, 5]
  },
  {
    title: "ピカチュウ or ミミッキュ",
    icon: <VideoCameraBackIcon />,
    color: deepOrange,
    url: "https://maitaketeikoku.github.io/pikachu_mimikyu/",
    public: true,
    tags: [2, 4, 6]
  },
  {
    title: "AI予言（Bluesky）",
    icon: <UpdateIcon />,
    color: lime,
    url: "https://bsky.app/profile/yogenshimasu.bsky.social",
    public: true,
    tags: [4]
  },
  {
    title: "画像生成（Bluesky）",
    icon: <FilterIcon />,
    color: lightGreen,
    url: "https://bsky.app/profile/original-images.bsky.social",
    public: true,
    tags: [4]
  },
  {
    title: "スマートレシピ検索",
    icon: <DinnerDiningIcon />,
    color: green,
    url: "https://maitake-recipe.pages.dev",
    public: false,
    tags: [2, 4, 5]
  },
  {
    title: "ポケモンクイズ",
    icon: <QuizIcon />,
    color: pink,
    url: "https://maitaketeikoku.github.io/pokemon-quiz/",
    public: true,
    tags: [3, 6]
  },
  {
    title: "ポケモンAIクイズ",
    icon: <PhotoFilterIcon />,
    color: amber,
    url: "https://ai-pokemon-quiz.pages.dev/",
    public: true,
    tags: [3, 4, 6]
  },
  {
    title: "生成AI知恵比べ",
    icon: <BalanceIcon />,
    color: deepPurple,
    url: "https://maitake-gai.pages.dev/",
    public: false,
    tags: [2, 4, 5]
  },
  {
    title: "まいたけAI",
    icon: <SmartToyIcon />,
    color: teal,
    url: "https://maitake-ai.pages.dev",
    public: false,
    tags: [2, 4, 5]
  },
  {
    title: "まいたけAIチャット",
    icon: <QuestionAnswerIcon />,
    color: purple,
    url: "https://maitake-chat.pages.dev/",
    public: true,
    tags: [2, 4, 5]
  },
  {
    title: "音声文字起こし",
    icon: <RecordVoiceOverIcon />,
    color: blue,
    url: "https://maitaketeikoku.github.io/maitake-speech/",
    public: true,
    tags: [2, 4, 5]
  },
  {
    title: "Blueskyポケポケフレンド募集一覧",
    icon: <PersonAddIcon />,
    color: indigo,
    url: "https://maitake-pokemontcgpocket.pages.dev/",
    public: true,
    tags: [2, 5, 6]
  },
  {
    title: "Bluesky解析",
    icon: <TrendingUpIcon />,
    color: cyan,
    url: "https://sites.google.com/view/maitake-bluesky/home",
    public: true,
    tags: [2, 5]
  },
  {
    title: "あつ森いきもの図鑑",
    icon: <BugReportIcon />,
    color: brown,
    url: "https://maitaketeikoku.github.io/atsumori-dex/",
    public: true,
    tags: [2]
  },
  {
    title: "ポケモン図鑑",
    icon: <CatchingPokemonIcon />,
    color: red,
    url: "https://maitaketeikoku.github.io/maitake-pokedex/",
    public: true,
    tags: [2, 6]
  },
  {
    title: "ポケポケカード図鑑",
    icon: <AllInboxIcon />,
    color: orange,
    url: "https://maitaketeikoku.github.io/maitake_pokepoke_dex/",
    public: true,
    tags: [2, 6]
  },
  {
    title: "IPアドレス",
    icon: <LanIcon />,
    color: blueGrey,
    url: "https://ip-access.pages.dev/",
    public: true,
    tags: [2, 5]
  },
  {
    title: "旧アプリ",
    icon: <HomeIcon />,
    color: blueGrey,
    url: "https://maitaketeikoku.github.io/MaitakeAuth/",
    public: true,
    tags: []
  }
];

const listStyle = {
  paddingLeft: 16
};
// ヘルプに表示する内容
export const helpList = [
  {
    title: "基本操作",
    contents: [
      {
        summary: "ご意見・お問い合わせ",
        details: (
          <div>
            <Link href="https://docs.google.com/forms/d/e/1FAIpQLSeX2wsW_hxwVU0YSJNVFWu3MYZcp_5thSwl55oZvvP9atgYvA/viewform?usp=sf_link" target="_blank">
              {"お問い合わせフォーム"}
            </Link>
            <Typography>
              {"バグの報告からご意見・ご要望など、何でも教えてね！"}
            </Typography>
          </div>
        )
      },
      {
        summary: "サインアウト",
        details: (
          <div>
            <SignOut />
          </div>
        )
      },
      {
        summary: "ニックネームの変更",
        details: (
          <div>
            <UpdateNickname />
          </div>
        )
      }
    ]
  },
  {
    title: "FAQ",
    contents: [
      {
        summary: "退会方法は？",
        details: (
          <div>
            <Typography>
              {"お問い合わせフォームで教えてね！"}
            </Typography>
          </div>
        )
      }
    ]
  },
  {
    title: "その他",
    contents: [
      {
        summary: "プライバシーポリシー",
        details: (
          <div>
            <Typography variant="caption">
              <ol style={listStyle}><li>
                {"Google Analyticsについて"}
                <ul style={listStyle}><li>
                  {"当サイトではGoogle Analyticsを利用しています。"}
                </li><li>
                    {"トラフィックデータの収集のためにCookieを使用しております。トラフィックデータは匿名で収集されており、個人を特定するものではありません。"}
                  </li></ul>
              </li></ol>
            </Typography>
          </div>
        )
      },
      {
        summary: "利用規約",
        details: (
          <div>
            <Typography variant="caption">
              <ol style={listStyle}><li>
                {"リンクについて"}
                <ul style={listStyle}><li>
                  {"当ブログは基本的にリンクフリーです。リンクを行う場合の許可や連絡は不要です。"}
                </li><li>
                    {"ただし、インラインフレームの使用や画像の直リンクは禁止します。"}
                  </li></ul>
              </li><li>
                  {"免責事項について"}
                  <ul style={listStyle}><li>
                    {"当サイトの情報や、当サイトのリンクやバナーなどで移動したサイトで提供される情報やサービス等について、損害等の一切の責任を負いません。"}
                  </li><li>
                      {"できる限り正確な情報を提供するように努めていますが、正確性や安全性を保証するものではありません。"}
                    </li></ul>
                </li><li>
                  {"著作権について"}
                  <ul style={listStyle}><li>
                    {"当サイトで掲載している文章や画像などにつきましては、無断転載することを禁止します。"}
                  </li><li>
                      {"当ブログは著作権や肖像権の侵害を目的としたものではありません。著作権や肖像権に関して問題がある場合、お問い合わせフォームよりご連絡ください。"}
                    </li></ul>
                </li></ol>
            </Typography>
          </div>
        )
      }
    ]
  }
];

// ウェルカム画面のサインインのステップ
export const stepList = [
  {
    label: "Googleでサインイン"
  },
  {
    label: "ニックネームを登録"
  }
];

// メイン画面のナビゲーション
export const navigationList = [
  { label: "ホーム", icon: <HomeIcon /> },
  { label: "ヘルプ", icon: <HelpIcon /> }
];
